import Autocomplete from "@mui/material/Autocomplete";
import styled from "styled-components";

interface IMargin {
  hasPermission: boolean;
}

interface StyledAutocompleteProps {
  $error?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  position: relative;
  padding: 0 30px;
`;

export const ContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;

export const ContainerInputs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
`;

export const ContainerInputsDate = styled.div<IMargin>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-right: ${(props) => (props.hasPermission ? 8 : 0)}px;
`;

// export const ContainerLoading = styled.div`
//   position: absolute;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 100%;
//   height: 100%;
//   background: rgb(0, 0, 0, 0.8);
// `;
// export const TextLoading = styled.p`
//   font-size: 16px;
//   color: #fff;
// `;

export const ContainerAutoComplete = styled.div`
  width: 100%;
  margin-top: 4px;

  .MuiAutocomplete-root {
    .MuiFormControl-root {
      margin-top: 0 !important;

      .MuiAutocomplete-inputRoot {
        padding: 11px 4px 9.9px 7px !important;
        width: 100% !important;
      }
    }
  }
`;

export const StyledAutocomplete = styled(Autocomplete)<StyledAutocompleteProps>`
  & .MuiFormControl-root {
    margin-top: 10px !important;
  }

  & .MuiFormHelperText-root {
    margin-left: 0 !important;
  }

  & .MuiInputLabel-root {
    font-size: 14px !important;
    font-weight: 400;
    font-family: "Inter", sans-serif !important;
    color: #666666 !important;
    line-height: 1.1375em !important;
  }

  & .MuiAutocomplete-inputRoot {
    width: 325px;
    font-size: 14px !important;
    font-weight: 400;
    font-family: "Inter", sans-serif !important;
    color: #666666 !important;
    padding: 6px 4px 7px 7px !important;
  }

  & .MuiOutlinedInput-root {
    border-radius: 4px;
    padding: 5px;

    & fieldset {
      border-width: 2px;
      border-color: ${({ $error }) =>
        $error ? "#d32f2f !important" : "#d1dbe3 !important"};
    }

    &:hover fieldset {
      border-color: ${({ $error }) =>
        $error ? "#d32f2f !important" : "#cbcbcb !important"};
    }

    &.Mui-focused fieldset {
      border-color: ${({ $error }) =>
        $error ? "#d32f2f !important" : "#1d9bf0 !important"};
    }
  }

  & .MuiInputBase-root {
    display: flex;
    align-items: center;
  }

  & .MuiAutocomplete-endAdornment {
    position: relative;
    top: unset;
    right: unset;
    transform: none;
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const SelectedHearingCard = styled.div`
  margin-top: 20px;
  margin-left: 30px;
  margin-right: 30px;
  width: calc(100% - 40px);
  background-color: #f5f5f5;
  padding: 16px 20px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 1px 3px rgba(15, 23, 42, 0.08);
`;

export const SelectedHearingItem = styled.p`
  margin: 6px 0;
  color: #344054;
  line-height: 1.4;

  strong {
    font-weight: 600;
    color: #475467;
    margin-right: 4px;
  }

  span {
    font-weight: 500;
    color: #101828;
  }
`;

export const MigrationContainer = styled.div`
  width: 100%;
  margin: 16px 0 0 0;
  color: #475467;

  .MuiFormControlLabel-root {
    margin: 0;
  }

  .MuiFormControlLabel-label {
    font-size: 14px;
    font-weight: 600;
    color: #475467;
  }
`;

export const MigrationTitle = styled.p`
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #98a2b3;
`;
